import { render, staticRenderFns } from "./DlgBranchNew.vue?vue&type=template&id=6243a1ab&scoped=true"
import script from "./DlgBranchNew.vue?vue&type=script&lang=js"
export * from "./DlgBranchNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6243a1ab",
  null
  
)

export default component.exports